import React, { useMemo } from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import MediumDevice from "./MEDIUMDEVICE";
import LargeDevice from "./LARGEDEVICE";

const Index = () => {
    const mdDevice = useMediaQuery("(max-width:1200px)");

    return useMemo(() => {
        if (mdDevice) {
            return <MediumDevice />
        } else {
            return <LargeDevice />
        }
    }, [mdDevice]);
}
export default Index;
